import { IconCalendar, IconClock, IconLogout, IconStethoscope } from "../../icons/IconsMedico";
import "./MedicoSidebar.css";

const NAV_ITEMS = [
    { key: "turnos", label: "Mis turnos", icon: <IconCalendar /> },
    { key: "disponibilidad", label: "Disponibilidad", icon: <IconClock /> },
    { key: "servicios", label: "Servicios", icon: <IconStethoscope /> },
];

const MedicoSidebar = ({ currentPage, activePage, onNavigate, user, onLogout }) => {
    const current = currentPage ?? activePage;
    return (
        <aside className="medico-sidebar">
            <a href="#medico-main-content" className="skip-link">Saltar al contenido principal</a>

            <div className="medico-sidebar__brand">
                <img
                    src="/logo192.png"
                    alt="Logo Sweet Medical"
                    className="admin-sidebar__logo"
                    style={{ width: '40px', height: '40px', objectFit: 'contain' }}
                />
                <span>Sweet Medical</span>
            </div>

            <div className="medico-sidebar__user">
                <div className="medico-sidebar__avatar" aria-hidden="true">
                    {(user?.displayName || user?.username || "U").charAt(0).toUpperCase()}
                </div>
                <div>
                    <p className="medico-sidebar__user-name">{user?.displayName || user?.username}</p>
                    <p className="medico-sidebar__user-role">Médico</p>
                </div>
            </div>

            <nav className="medico-sidebar__nav" aria-label="Navegación principal del panel de médico">
                {NAV_ITEMS.map((item) => (
                    <button
                        key={item.key}
                        className={`medico-sidebar__nav-item${current === item.key ? " medico-sidebar__nav-item--active" : ""}`}
                        onClick={() => onNavigate(item.key)}
                        aria-current={current === item.key ? "page" : undefined}
                    >
                        <span aria-hidden="true">{item.icon}</span>
                        <span>{item.label}</span>
                    </button>
                ))}
            </nav>

            <button className="medico-sidebar__logout" onClick={onLogout} aria-label="Cerrar sesión">
                <IconLogout aria-hidden="true" />
                <span>Cerrar sesión</span>
            </button>
        </aside>
    );
};

export default MedicoSidebar;